export const PORTAL_VERSION = '2.8.20';
